import ExportDocumentRequest from "../../libs/core-api-requests/dirs/exportDocumentRequest";
import { IExportToolsDTO, IExportToolsViewDTO } from "../../libs/coreapi-dto/dirs/exportDocument";
import CoreApiService from "../../system/api/coreApiService";
import { DictionaryDataProvider } from "./Common/DictionaryDataProvider";

export class ExportDocumentDataProvider extends DictionaryDataProvider<
IExportToolsViewDTO,
IExportToolsDTO
> {

     private _coreApiService: CoreApiService;

    constructor(coreApiService: CoreApiService){
        super();
        this._coreApiService = coreApiService;
    }

    getDataRequest(): Promise<ExportDocumentRequest> {
        return this._coreApiService.exportDocumentRequest;
    }

    getDefault(idTableVariant: number, callback?: (entity: IExportToolsDTO) => void) {
        this.getDataRequest()
            .then(r =>
                r.getDefault(idTableVariant, (e) => {
                    try {
                        if (e.respType === 'isCompleted') {
                            callback?.(e.data);
                        } else {
                            throw new Error(e.message.detail);
                        }
                    } catch (error) {
                        console.error(error);
                    }
                })
            );
    }
}